<template>
  <div class="animated fadeIn">
    <div v-if="$route.name == 'Staff'" class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify" /> Staff
            <router-link
              :to="'/admin/staff/new'"
              class="pull-right btn btn-success btn-sm"
              exact
            >
              New
            </router-link>
          </div>
          <div class="card-block">
            <input
              v-model="searchQuery"
              type="text"
              class="form-control"
              placeholder="Search by person title"
            >
          </div>
          <div class="card-block spinner-parent">
            <spinner ref="spinner" size="md" text="Loading ..." />

            <nav>
              <pager
                :total="total"
                :offset="offset"
                :size="perPage"
                @page-changed="$_changePage"
              />
            </nav>
            <div class="table-responsive">
              <table v-if="total" class="entities table table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Title</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in entities" :key="item.id" :data-id="item.id">
                    <td>{{ item.id }}</td>
                    <td>{{ item.title }}</td>
                    <td class="table-list__cell--narrow">
                      <router-link
                        class="btn btn-primary btn-sm"
                        :to="{ name: 'StaffEdit', params: { id: item.id }}"
                      >
                        Edit
                      </router-link>
                      <button class="btn btn-danger btn-sm" @click="$_deleteEntity(item, 'staff/', 'Staff')">
                        Delete <span :ref="`deleteBtnLoader_${item.id}`" class="btn-loader" style="display: none;" />
                      </button>
                      <open-on-site
                        :source-route="item.route"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="total === 0">There are no entities for your request</div>
            <nav>
              <pager
                :total="total"
                :offset="offset"
                :size="perPage"
                @page-changed="$_changePage"
              />
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Pager from '@/global/components/Pager';
import OpenOnSiteButton from '@/global/components/OpenOnSiteButton';
// Mixins
import ListPageMixin from '@/mixins/ListPageMixin';
import CommonPageMixin from '@/mixins/CommonPageMixin';

export default {
  name: 'StaffList',

  components: {
    pager: Pager,
    'open-on-site': OpenOnSiteButton,
  },

  mixins: [ListPageMixin, CommonPageMixin],

  methods: {
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      const searchString = encodeURI(this.searchQuery);
      const page = this.perPage ? (this.offset / this.perPage + 1) : 1;
      const searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(`${this.$config.app_api.prefix}staff?search_string=${searchString}&page=${page}`)
        .then((response) => {
          if (this.searchProcessId === searchProcessId) {
            if (this.$refs.spinner) { this.$refs.spinner.hide(); }
            this.total = response.data.meta.pagination.total;
            this.perPage = response.data.meta.pagination.per_page;

            const staffArr = _.cloneDeep(response.data);
            delete staffArr.meta;
            this.entities = staffArr;
          }
        })
        .catch((error) => { this.$_errorCallback(error); });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Index.vue?10f4b30e